import styled from 'styled-components'
import WhatsappIcon from "../Images/WhatsappIcon";
import { isMobileOrTabletUser } from '../../lib/utils';

export const StyledWhatsappIcon = styled(WhatsappIcon)`
  margin-left: 8px;
  width: 16px;
  height: 16px;
`
export const Container = styled.div`
  background-color: var(--Grey300);
  height: 100vh;
  display: flex;
  align-items: center;
  background-size: cover;
  width: 100%;
`
export const MainDiv = styled.div`
  display: flex;
  margin: auto;
  width: 900px;
  min-height: 540px;
  @media(max-width: 600px){
    width:100vw;
    flex-direction: column;
    // margin-right: 16px;
  }
`
export const LeftDiv = styled.div`
  background-color: var(--FjordDark300);
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    display: none;
  }
`
export const RightDiv = styled.div`
  position: relative;
  width: 50%;
  padding: 48px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    width: 100%;
    padding: 16px;
    height: 100vh;
  }
`
export const IconHolder = styled.div`
`
export const LogoHolder = styled.div`
  text-align: center;
  margin-bottom:${isMobileOrTabletUser() ? "1rem": "40px"};
`
export const LoginHeading = styled.div`
  font-size: 20px;
  font-weight: bold;
  line-height: 1.2;
  text-align: left;
  color: var(--Text700);
  margin-bottom: 16px;
`
export const LoginButton = styled.button `
  outline: none;
  border: none;
  padding:${isMobileOrTabletUser() ? "10px" : "14px"};
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
  background-color: var(--Azure500);
  font-size: 14px;
  font-weight: bold;
  line-height: 1.43;
  text-align: left;
  color: rgba(255, 255, 255, 0.98);
  text-transform: uppercase;
  text-align: center;
  margin-bottom:${isMobileOrTabletUser() ? "0.5rem" : "1rem"};
  opacity: ${({ disabled }) => disabled ? 0.3 : 1};
`
export const ContactUsDiv = styled.div`
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translate(-50%, 0);
  font-size: 12px;
  font-weight: 500;
  line-height: 1.35;
  color: var(--Text500);
  margin-top:${isMobileOrTabletUser() ? "0.5rem" : "1rem"};
`
export const ContactUsButton = styled.a`
  margin-left: 4px;
  text-decoration: None;
  color: var(--Azure500);
`
export const OtpTitle = styled.div`
  font-size: 20px;
  font-weight: bold;
  line-height: 1.2;
  text-align: left;
  color: var(--Text700);
  margin-bottom:${isMobileOrTabletUser() ? "0.5rem" : "1rem"};
`
export const ResendMessage = styled.span`
  color: var(--lime-700);
  font-size: 12px;
  font-style: italic;
`

export const HelpText = styled.div`
  font-size: 12px;
  line-height: 1.33;
  text-align: left;
  color: var(--Text300);
  margin-bottom:${isMobileOrTabletUser() ? "0.5rem" : "24px"};
`
export const ActionButtons = styled.div`
  display: flex;
  justify-content: space-between;
`
export const ResendOtp = styled.button`
  background: none;
  outline: none;
  width: 47%;
  border-radius: 4px;
  border: solid 2px #e7e8eb;
  padding:${isMobileOrTabletUser() ? "0.5rem" : "14px"};
  display: flex;
  justify-content: center;
  font-size:${isMobileOrTabletUser() ? "10px" : "14px"};
  font-weight: bold;
  line-height: 1.43;
  text-align: left;
  color: var(--Text100);
  cursor: pointer;
`
export const ResendOtpEnabled = styled(ResendOtp)`
  color: var(--Text500);
  align-items: center;
`
export const ChangeNumber = styled.a`
  color: var(--Text500);
  text-decoration: none;
  width: 47%;
  border-radius: 4px;
  border: solid 2px #e7e8eb;
  padding:${isMobileOrTabletUser() ? "0.5rem" : "14px"};
  display: flex;
  justify-content: center;
  font-size:${isMobileOrTabletUser() ? "10px" : "14px"};
  font-weight: bold;
  line-height: 1.43;
  text-align: left;
  cursor: pointer;
`
export const WrongOtpSpan = styled.span`
  color: var(--Punch500);
  font-size: 12px;
  font-style: italic;
`
export const MessageDiv = styled.div`
  font-size: 16px;
  line-height: 1.5;
  text-align: center;
  color: var(--Text700);
`
export const ErrorMessageDiv = styled(MessageDiv)`
  color: var(--Punch500);
  margin-top: 80px;
`
export const HomeRedirectButton = styled(ContactUsButton)``

export const SetupHeading = styled(LoginHeading)`
  // margin-top: -30px;
  font-size:17px;
`

export const InputContainer = styled.div`
  margin-bottom: 16px;
`
export const RadioLabel = styled.div`
  font-size: 16px;
  line-height: 1.5;
  color: ${({ invalid }) => invalid ? 'var(--Punch500)' : 'var(--Text700)'};
`
export const LabelErrorSpan = styled.span`
  font-style: italic;
  font-size: 12px;
`
export const OptionsContainer = styled.div`
  margin-top: 8px;
  display: flex;
  height: 50px;
  justify-content: space-between;
`
export const LangOptionsContainer = styled.div`
  margin-top: 8px;
`
export const RadioOption = styled.div`
  display: flex;
  align-items: center;
  padding: 13px 10px;
  border-radius: 4px;
  border: solid 1px var(--Grey900);
  background-color: ${({ active }) =>
    active ? ' var(--Azure500)' : 'var(--Grey300)'};
  // margin-right: 16px;
`
export const LangRadioOption = styled(RadioOption)`
  margin-bottom: 8px;
`
export const RadioIcon = styled.div`
  width: 16px;
  height: 16px;
  border: ${({ active }) =>
    active ? 'solid 1px var(--TextDark500)' : 'solid 1px var(--Text500)'};
  padding: 3px;
  border-radius: 50%;
  margin-right: 8px;
  display: flex;
  align-items: center;
`
export const RadioNameSpan = styled.span`
  font-size: 16px;
  font-weight: 500;
  line-height: 1.4;
  color: ${({ active }) => (active ? 'var(--TextDark700)' : 'var(--Text500)')};
`

export const WhatAppInfoContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #64B161;
`
export const WhatAppCheckBox = styled.input`
  accent-color: #09a603;
  width: 25px;
  height: 16px;
`

// const LoginForm = styled.div`
//   height: 469px;
// `
// const Title = styled.div`
//   height: 34px;
//   text-align: center;
//   padding-top: 40px;
//   font-size: 24px;
//   font-weight: 600;
//   line-height: 1.4;
//   color: var(--Text700);
// `
// const LoginDetails = styled.div`
//   padding-left: 24px;
//   padding-right: 24px;
//   padding-top: 77px;
//   color: var(--Text500);
//   margin-bottom: 110px;
// `
// const InputLabel = styled.div`
//   height: 16px;
//   font-size: 12px;
//   font-weight: 500;
//   line-height: 1.35;
//   color: ${({ invalid }) => invalid ? 'var(--Punch500)' : 'var(--Text500)'};
// `
// const LabelErrorSpan = styled.span`
//   font-style: italic;
// `
// const LoginButtonContainer = styled.div`
//   height: 48px;
//   margin-top: 16px;
//   border-radius: 4px;
//   border: solid 1px var(--Grey900);
// `
// const LoginButton = styled.button`
//   display: inline-block;
//   padding: 13px;
//   width: 100%;
//   border-radius: 4px;
//   text-decoration: none;
//   border-width: 0;
//   text-align: center;
//   font-size: 16px;
//   font-weight: 600;
//   line-height: 1.4;
//   color: var(--TextDark700);
//   background-color: var(--Azure500);
//   cursor: pointer;
//   opacity: ${({ disabled }) => disabled ? '0.3' : '1'};
// `
// const RedirectDiv = styled.div`
//   height: 16px;
//   margin-top: 16px;
//   font-size: 12px;
//   font-weight: 500;
//   line-height: 1.35;
// }
// `
// const RedirectButton = styled.span`
//   margin-left: 4px;
//   text-decoration: None;
//   color: var(--Azure500);
//   cursor: pointer;
// `
// const ContactUsDiv = styled.div`
//   text-align: center;
//   font-size: 12px;
//   font-weight: 500;
//   line-height: 1.35;
//   color: var(--Text500);;
// }
// `
// const ContactUsButton = styled.a`
//   margin-left: 4px;
//   text-decoration: None;
//   color: var(--Azure500);
// `
// export {
//   LoginForm,
//   Title,
//   LoginDetails,
//   InputLabel,
//   LabelErrorSpan,
//   LoginButtonContainer,
//   LoginButton,
//   RedirectButton,
//   RedirectDiv,
//   ContactUsDiv,
//   ContactUsButton
// }
